<template>
  <section
    v-guides-view-tracker="getGuidesViewEventParams"
    class="guides"
  >
    <GuideListItem
      v-for="guide in currentList"
      :key="guide.id"
      :default-sogu-fields="defaultSoguFields"
      :guide="guide"
      :has-tours="hasTours"
    />
  </section>
</template>
<script setup lang="ts">
  import { GuideListItem } from '@/entities/guide';
  import type { Guide } from '@/shared/api/experience';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';
  import { useViewTracker } from '@/entities/sogu';

  interface Props {
    currentList: Guide[];
    hasTours?: boolean;
    defaultSoguFields: ContextGeoSubject;
  }

  const props = defineProps<Props>();

  const getGuidesViewEventParams = () => props.defaultSoguFields.soguStamp;
  const vGuidesViewTracker = useViewTracker('listing:guides.view');
</script>
